export default [
  {
    /* themeConfig.js에서 layout type을 'horizontal'로 사용할 때 메뉴 구성 */
  },
]
